import { Icon, Style } from "ol/style"
import { statusDisplay } from "./status"

// Permanent zoom-in labels, pre-rendered to a per-device canvas (legacy tooltip look:
// white rounded box with tail, org icon, name, status badge) and blitted as an Icon —
// cheaper per frame than canvas text and not limited to rectangular backgroundFill.

const SCALE = 2 // render @2x, display at 0.5 — crisp on retina like the @2 marker icons

const TAIL        = 6   // left-pointing triangle toward the marker
const PAD_X       = 8
const HEIGHT      = 28
const ICON_SIZE   = 16
const GAP         = 6
const BADGE_PAD_X = 7
const BADGE_H     = 18
const MARKER_GAP  = 12  // css px between marker tip and tail
const RAISE       = 22  // css px the box center sits above the marker tip
const NAME_FONT   = "600 13px system-ui, sans-serif"
const BADGE_FONT  = "700 12px system-ui, sans-serif"

const measureCtx = document.createElement("canvas").getContext("2d")
const orgIcons = new Map() // url -> shared HTMLImageElement

function orgIcon(url, onLoad) {
    let img = orgIcons.get(url)
    if (!img) {
        img = new Image()
        img.src = url
        orgIcons.set(url, img)
    }
    const ready = img.complete && img.naturalWidth > 0
    if (!ready) img.addEventListener("load", onLoad, { once: true })
    return ready ? img : null
}

// onIconLoad: called once the shared org icon finishes loading — rebuild the style then.
export function labelStyle({ name, status, iconUrl }, onIconLoad) {
    const { text, bg, fg } = statusDisplay(status)
    const icon = iconUrl ? orgIcon(iconUrl, onIconLoad) : null

    measureCtx.font = NAME_FONT
    const nameWidth = Math.ceil(measureCtx.measureText(name).width)
    measureCtx.font = BADGE_FONT
    const badgeWidth = Math.ceil(measureCtx.measureText(text).width) + 2 * BADGE_PAD_X
    const boxWidth = PAD_X + (icon ? ICON_SIZE + GAP : 0) + nameWidth + GAP + badgeWidth + PAD_X

    const canvas = document.createElement("canvas")
    canvas.width = (TAIL + boxWidth) * SCALE
    canvas.height = HEIGHT * SCALE
    const ctx = canvas.getContext("2d")
    ctx.scale(SCALE, SCALE)
    const midY = HEIGHT / 2

    ctx.fillStyle = "#ffffff"
    ctx.beginPath()
    ctx.roundRect(TAIL, 0, boxWidth, HEIGHT, 5)
    ctx.moveTo(0, midY)
    ctx.lineTo(TAIL + 1, midY - TAIL)
    ctx.lineTo(TAIL + 1, midY + TAIL)
    ctx.closePath()
    ctx.fill()

    let x = TAIL + PAD_X
    ctx.textBaseline = "middle"
    if (icon) {
        ctx.drawImage(icon, x, midY - ICON_SIZE / 2, ICON_SIZE, ICON_SIZE)
        x += ICON_SIZE + GAP
    }
    ctx.font = NAME_FONT
    ctx.fillStyle = "#212529"
    ctx.fillText(name, x, midY)
    x += nameWidth + GAP

    ctx.fillStyle = bg
    ctx.beginPath()
    ctx.roundRect(x, midY - BADGE_H / 2, badgeWidth, BADGE_H, 4)
    ctx.fill()
    ctx.font = BADGE_FONT
    ctx.fillStyle = fg
    ctx.textAlign = "center"
    ctx.fillText(text, x + badgeWidth / 2, midY)

    return new Style({
        image: new Icon({
            img: canvas,
            scale: 1 / SCALE,
            anchorXUnits: "pixels",
            anchorYUnits: "pixels",
            // geometry point: MARKER_GAP left of the tail, RAISE below the box center
            anchor: [-MARKER_GAP * SCALE, (HEIGHT / 2 + RAISE) * SCALE]
        })
    })
}
